import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15 4c0-.5523.4477-1 1-1h4c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1V5h-3c-.5523 0-1-.4477-1-1",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20.7071 3.2929c.3905.3905.3905 1.0237 0 1.4142l-6 6c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l6-6c.3905-.3905 1.0237-.3905 1.4142 0M4 15c.5523 0 1 .4477 1 1v3h3c.5523 0 1 .4477 1 1s-.4477 1-1 1H4c-.5523 0-1-.4477-1-1v-4c0-.5523.4477-1 1-1",
        clipRule: "evenodd"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.7071 13.2929c.3905.3905.3905 1.0237 0 1.4142l-6 6c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l6-6c.3905-.3905 1.0237-.3905 1.4142 0M20 15c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1h-4c-.5523 0-1-.4477-1-1s.4477-1 1-1h3v-3c0-.5523.4477-1 1-1",
        clipRule: "evenodd"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.2929 13.2929c.3905-.3905 1.0237-.3905 1.4142 0l6 6c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-6-6c-.3905-.3905-.3905-1.0237 0-1.4142M3 4c0-.5523.4477-1 1-1h4c.5523 0 1 .4477 1 1s-.4477 1-1 1H5v3c0 .5523-.4477 1-1 1s-1-.4477-1-1z",
        clipRule: "evenodd"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.2929 3.2929c.3905-.3905 1.0237-.3905 1.4142 0l6 6c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-6-6c-.3905-.3905-.3905-1.0237 0-1.4142",
        clipRule: "evenodd"
    }, "4")
], "ArrowsMaximize", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
